import { styled } from '@mui/material';
import { Button, ButtonOutline } from '@/components/buttons';

export const Wrapper = styled('div')`
  border-radius: ${({ theme }) => theme.spacing(4)};
  background: ${({ theme }) => theme.palette.primary[50]};
  padding-bottom: ${({ theme }) => theme.spacing(1)};
`;

export const GroupTitle = styled('h1')`
  font-size: ${({ theme }) => theme.spacing(9.5)};
  color: ${({ theme }) => theme.palette.primary[900]};
  line-height: 1.15;
  font-weight: 700;
  flex: 1;
`;

export const GroupSubtitle = styled('h2')`
  font-size: ${({ theme }) => theme.spacing(4.5)};
  margin-top ${({ theme }) => theme.spacing(1)};
  line-height: 1.4;
`;

export const JoinButton = styled(Button)`
  height: 51px;
  width: 141px;

  font-size: 18px;
  font-weight: bold;
  line-height: 21px;

  padding: 15px 18px;

  color: #ffffff;

  @media (max-width: 768px) {
    width: 87px;
    height: 33px;
    font-size: 12px;
    padding: 6px 10px;
    font-weight: normal;
  }
`;

export const LeaveButton = styled(ButtonOutline)`
  background-color: transparent;

  height: 51px;

  font-size: 18px;
  font-weight: bold;
  line-height: 21px;

  border: 2px solid #5fa3a9;

  @media (max-width: 768px) {
    height: 33px;
    font-size: 12px;
    padding: 6px 10px;
  }
`;
